import { ReactElement } from 'react';
import { HotelWidget } from '@/components/hotelWidget/HotelWidget';
import { Filters } from '@/domain';

type Positions = { id: string; position: number; type: string };

export const resultListBanners = (bannerPositionsReversed: Positions[], filters: Filters, items: ReactElement[]) => {
    bannerPositionsReversed.forEach((bannerPosition) => {
        if (bannerPosition.type === 'hotel_widget') {
            items.splice(
                items && items.length >= bannerPosition.position ? bannerPosition.position : items.length,
                0,
                <HotelWidget key={`article_cw__${bannerPosition.id}`} filters={filters} />
            );
        }
    });
    return items;
};

export const insertHotelWidget = (id: string = 'hotel_widget_1', position: number, filters: Filters, items: ReactElement[]) => {
    if (items && items.length >= position) {
        items.splice(position, 0, <HotelWidget key={`article_cw__${id}`} filters={filters} />);
    }
    return items;
};
